import { Chip } from "@mui/material";

export const statusAdministrationRender = (params) => {
  if (!params.data || !params.data.accountType) return params.value; // Bez greške ako je undefined

  switch (params.data.accountType) {
    case "COUNTRY_ADMIN":
      return <Chip label="Administrator države" color="info" size="small" />;
    case "SUPER_ADMIN":
      return <Chip label="Master administrator" color="warning" size="small" />;
    case "BASIC_USER":
      return <Chip label="Prodavac" color="info" size="small" />;
    case "MANAGER":
      return <Chip label="Menadžer" color="warning" size="small" />;
    default:
      return <Chip label="Nepoznat" color="default" size="small" />; // Sigurnosni fallback
  }
};

export const statusRender = (params) => {
  if (!params.data || !params.data.status) return params.value;

  switch (params.data.status) {
    case "INACTIVE":
      return <Chip label="Neaktivan" color="error" size="small" />;
    case "ARCHIVE":
      return <Chip label="Arhiviran" color="warning" size="small" />;
    case "ACTIVE":
      return <Chip label="Aktivan" color="success" size="small" />;
    default:
      return <Chip label="Nepoznat" color="default" size="small" />; // Sigurnosni fallback
  }
};

export const statusTypeRender = (params) => {
  if (!params.data || !params.data.type) return params.value;

  switch (params.data.type) {
    case "LEVEL_UP":
      return (
        <Chip label="Prelazak na sledeci nivo" color="info" size="small" />
      );
    case "POINTS":
      return <Chip label="Osvajanjem poena" color="warning" size="small" />;
    default:
      return <Chip label="Nepoznat" color="default" size="small" />; // Sigurnosni fallback
  }
};

export const statusSectorRender = (params) => {
  if (!params.data || !params.data.sector) return params.value;

  switch (params.data.sector) {
    case "DEVICE_FOR_HOUSE":
      return <Chip label="Aparati za kuću" color="info" size="small" />;
    case "TV_AUDIO":
      return <Chip label="TV/Audio" color="warning" size="small" />;
    case "DEVICE_FOR_HOUSE_AND_TV_AUDIO":
      return (
        <Chip label="Aparati za kuću i TV/Audio" color="success" size="small" />
      );
    default:
      return <Chip label="Nepoznat" color="default" size="small" />; // Sigurnosni fallback
  }
};

export const statusRenderRewawrd = (params) => {
  if (!params.data || !params.data.status) return params.value; // Bez greške ako je undefined
  switch (params.data.status) {
    case "PENDING":
      return <Chip label="Na čekanju" color="warning" size="small" />;
    case "CANCELLED":
      return <Chip label="Storinirano" color="info" size="small" />;
    case "APPROVED":
      return <Chip label="Odobreno" color="success" size="small" />;
    case "REJECTED":
      return <Chip label="Odbijeno" color="error" size="small" />;
    default:
      break;
  }
};

export const statusNotificationRender = (params) => {
  if (!params.data || !params.data.status) return params.value; // Bez greške ako je undefined
  switch (params.data.status) {
    case "PREPARED":
      return <Chip label="Na čekanju za slanje" color="warning" size="small" />;
    case "FINISHED":
      return <Chip label="Poslato" color="success" size="small" />;
    case "IN_PROGRESS":
      return <Chip label="U procesu slanja" color="info" size="small" />;
    default:
      break;
  }
};

export const typeNotificationRender = (params) => {
  if (!params.data || !params.data.type) return params.value; // Bez greške ako je undefined
  switch (params.data.type) {
    case "APP":
      return <Chip label="Aplikativna" color="info" size="small" />;
    case "MAIL":
      return <Chip label="Email" color="info" size="small" />;
    case "BOTH":
      return <Chip label="Aplikativna i email" color="info" size="small" />;
    default:
      break;
  }
};

export const statusRenderOrder = (params) => {
  if (!params.data || !params.data.status) return params.value; // Bez greške ako je undefined
  switch (params.data.status) {
    case "PENDING":
      return <Chip label="Na čekanju" color="warning" size="small" />;
    case "APPROVED":
      return <Chip label="Odobreno" color="success" size="small" />;
    case "REJECTED":
      return <Chip label="Odbijeno" color="error" size="small" />;
    default:
      break;
  }
};

export const statusRenderActivate = (params) => {
  if (!params.data || !params.data.status) return params.value; // Bez greške ako je undefined
  switch (params.data.status) {
    case "Neaktivan":
      return <Chip label="Neaktivan" color="error" />;
    case "Aktivan":
      return <Chip label="Aktivan" color="success" />;
    default:
      break;
  }
};

export const statusRenderStatus = (params) => {
  switch (params.data.payment_status_name) {
    case "U obradi":
      return (
        <Chip
          label="U obradi"
          size="small"
          sx={{
            backgroundColor: "#FFE0B2", // Nova pastelna narandžasta
            color: "#EF6C00", // Tamnija narandžasta za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Poručeno":
      return (
        <Chip
          label="Poručeno"
          size="small"
          sx={{
            backgroundColor: "#E3F2FD", // Blaga plava
            color: "#1565C0", // Tamnija plava za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Plaćeno":
      return (
        <Chip
          label="Plaćeno"
          size="small"
          sx={{
            backgroundColor: "#E8F5E9", // Blaga zelena
            color: "#2E7D32", // Tamnija zelena za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Nije plaćeno":
      return (
        <Chip
          label="Nije plaćeno"
          size="small"
          sx={{
            backgroundColor: "#F3E5F5", // Blaga ljubičasta
            color: "#6A1B9A", // Tamnija ljubičasta za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Odbijeno":
      return (
        <Chip
          label="Odbijeno"
          size="small"
          sx={{
            backgroundColor: "#FFEBEE", // Blaga crvena
            color: "#C62828", // Tamnija crvena za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Nepoznat status":
      return (
        <Chip
          label="Nepoznat status"
          size="small"
          sx={{
            backgroundColor: "#ECEFF1", // Blaga siva
            color: "#37474F", // Tamnija siva za tekst
            borderRadius: "4px",
          }}
        />
      );
    default:
      break;
  }
};

export const statusRenderStatusDelivery = (params) => {
  switch (params.data.is_delivery_name) {
    case "Nije isporučeno":
      return (
        <Chip
          label="Nije isporučeno"
          size="small"
          sx={{
            backgroundColor: "#FFEBEE", // Blaga crvena
            color: "#C62828", // Tamnija crvena za tekst
            borderRadius: "4px",
          }}
        />
      );
    case "Isporučeno":
      return (
        <Chip
          label="Isporučeno"
          size="small"
          sx={{
            backgroundColor: "#E8F5E9", // Blaga zelena
            color: "#2E7D32", // Tamnija zelena za tekst
            borderRadius: "4px",
          }}
        />
      );
    default:
      break;
  }
};

export const primaryRender = (params) => {
  switch (params.data.isPrimary) {
    case false:
      return <Chip label="Ne" color="error" variant="outlined" />;
    case true:
      return <Chip label="Da" color="success" variant="outlined" />;
    default:
      break;
  }
};
